import React, { useState, useEffect } from 'react';

// زمن أقصى للتحميل (مللي ثانية) لتحديد الاتصال الضعيف
const POOR_CONNECTION_THRESHOLD = 3000;

const InternetStatusChecker = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isPoorConnection, setIsPoorConnection] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  // تحقق من جودة الاتصال عن طريق اختبار سرعة استجابة خادم صغير
  const checkConnectionQuality = async () => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), POOR_CONNECTION_THRESHOLD);

    const start = Date.now();
    try {
      await fetch('https://www.gstatic.com/generate_204', { signal: controller.signal });
      const duration = Date.now() - start;
      setIsPoorConnection(duration > POOR_CONNECTION_THRESHOLD);
    } catch {
      // عند الخطأ نفترض أن الاتصال ضعيف أو معدوم
      setIsPoorConnection(true);
    } finally {
      clearTimeout(timeoutId);
    }
  };

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      checkConnectionQuality();
      setShowMessage(true);
      setTimeout(() => setShowMessage(false), 3000); // إخفاء الرسالة بعد 3 ثواني
    };
    const handleOffline = () => {
      setIsOnline(false);
      setShowMessage(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    if (navigator.onLine) {
      checkConnectionQuality();
    } else {
      setShowMessage(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  // أنماط الحركة (CSS-in-JS)
  const animationStyle = {
    animation: 'fadeIn 0.7s ease forwards',
  };

  // مفتاح الحركات في CSS عام
  const globalStyle = `
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(-10px);}
      to { opacity: 1; transform: translateY(0);}
    }
  `;

  if (!isOnline) {
    return (
      <>
        <style>{globalStyle}</style>
        <div
          style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: '1em',
            backgroundColor: '#6A2F38',
            color: '#fff',
            fontFamily: 'Tahoma, Arial, sans-serif',
            ...animationStyle,
          }}
        >
          <h2>لا يوجد اتصال بالإنترنت</h2>
          <p>يرجى التحقق من إعدادات الشبكة والمحاولة مرة أخرى.</p>
          <button
            onClick={handleReload}
            style={{
              marginTop: '1em',
              padding: '0.5em 1.5em',
              fontSize: '1rem',
              backgroundColor: '#D4AD89',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            إعادة التحميل
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{globalStyle}</style>
      {showMessage && isPoorConnection && (
        <div
          style={{
            position: 'fixed',
            bottom: 20,
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#ff9800',
            color: '#000',
            padding: '0.75em 1.5em',
            borderRadius: '5px',
            fontWeight: 'bold',
            fontFamily: 'Tahoma, Arial, sans-serif',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            ...animationStyle,
            zIndex: 9999,
          }}
          role="alert"
          aria-live="assertive"
        >
          اتصال الإنترنت ضعيف. قد تواجه بطء في التصفح.
        </div>
      )}
      {children}
    </>
  );
};

export default InternetStatusChecker;
